<template>
  <div
    v-show="show"
    :class="computedWrapperCssClass"
    :style="computedWrapperCssStyle"
  >
    <slot>
      <form-validation
        :label="label"
        :id="identity"
        :name="name"
        :show="showValidation"
        :css-class="computedValidationCssClass"
        :validation="computedValidation"
        :error="error"
      ></form-validation>
    </slot>
    <input
      :type="inputType"
      :id="identity"
      :name="name"
      :value="value"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      class="input"
      :class="inputCssClass"
      v-focus="focus"
      v-on="inputListeners"
      :disabled="isDisabled"
      v-bind="attributeBindings"
    />
  </div>
</template>
<script>
import BaseTextInput from '@ssdcode/vue-form/src/components/Form/Inputs/Input/BaseTextInput';
export default {
  mixins: [BaseTextInput],
  props: {
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      inputType: this.type,
    };
  },
};
</script>
